/* eslint-disable react/button-has-type */
import { prefixPath } from '../../utils/helpers';
import card from '../../images/CreditCard.svg';
import styles from '../../css/success.module.css';

const SuccessBody = () => {
  const toDashboard = prefixPath('/dashboard');
  const params: any = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop: any) => searchParams.get(prop),
  });

  let {
    // eslint-disable-next-line prefer-const
    linkname, linkvalue, additionalprotocol,
  } = params;

  // const marketPlaceSource = localStorage.getItem('market_place_source');
  // const IndexOfZDFS = linkvalue ? linkvalue.indexOf('zdfs/files') : -1;
  // const IndexOfEndpoint = linkvalue ? linkvalue.indexOf('/app/endpoints') : -1;
  // const IndexOfPlygonCDK = linkvalue ? linkvalue.indexOf('/validium/networks') : -1;
  // if (marketPlaceSource && marketPlaceSource === 'marketplace' && IndexOfZDFS === -1 && IndexOfEndpoint === -1 && IndexOfPlygonCDK === -1) {
  //   linkvalue = '/platform/manage/nodes/full';
  // } else if (marketPlaceSource && marketPlaceSource === 'staking-nodes' && IndexOfZDFS === -1 && IndexOfEndpoint === -1 && IndexOfPlygonCDK === -1) {
  //   linkvalue = '/platform/manage/nodes/validator';
  // } else if (marketPlaceSource && marketPlaceSource === 'subscriptionUpdate') {
  //   linkvalue = '/app/Account';
  // } else if (marketPlaceSource && marketPlaceSource === 'subgraph' && IndexOfZDFS === -1 && IndexOfEndpoint === -1 && IndexOfPlygonCDK === -1) {
  //   linkvalue = '/subgraph/create-subgraph';
  // } else if (marketPlaceSource && marketPlaceSource === 'graph-node' && IndexOfZDFS === -1 && IndexOfEndpoint === -1 && IndexOfPlygonCDK === -1) {
  //   linkvalue = '/subgraph/graph-node';
  // }

  return (
    <section
      className={`${styles['banner-banner']} px-5 col-xl-12 col-lg-12 col-md-12 col-sm-12 workspace mb-3`}
    >
      <div className="my-5 row align-items-center">
        <div className={styles['message-all']}>
          <div className={styles['message-2']}>
          <img src={card} alt="card" className={styles.card} />
          <h5>Your payment has been completed successfully!</h5>
          {additionalprotocol
            ? (
            <div className={styles['message-2']}>
              <div>
                <h5>Our team will reach out to you very quickly regarding your node(s).</h5>
              </div>
            </div>
            )
            : (
            <div>
              {}
            </div>
            )}
          </div>
        </div>
        <div
      className={additionalprotocol ? 'text-center' : 'col-xl-6 col-lg-6 col-md-6 col-sm-6 btndashboard'}
        >
          <a href={toDashboard} className="">
            <button
                className={styles['button-dashboard']}
            >
                  Go to Dashboard
            </button>
          </a>
        </div>
        {additionalprotocol
          ? (
            <div>
              {}
            </div>
          )
          : (
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 btnsetnode">
              <a href={linkvalue} className="activeTextColor d-flex text-decoration-none">
                <span className="">
                  {linkname}
                  {' '}
                  <i className="fa fa-arrow-right mx-2" />
                </span>
              </a>
            </div>
          )}
      </div>
    </section>
  );
};
export default SuccessBody;